import Link from "next/link";

import { getIconForTitle } from "@/features/marketing-content/utils/icon-map";

import type { ReboltDetail } from "@/content/alternatives/schema";

export function ReboltDetailSection({ heading, description, features, pricing }: ReboltDetail) {
  const headingParts = heading.split("Rebolt");

  return (
    <section className="bg-ash-100 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="font-clash text-3xl font-medium leading-tight tracking-snug text-ash-900 md:text-5xl">
            {headingParts.length > 1 ? (
              <>
                {headingParts[0]}
                <span className="text-rebolt-500">Rebolt</span>
                {headingParts[1]}
              </>
            ) : (
              heading
            )}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ash-500">{description}</p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => {
            const Icon = getIconForTitle(feature.title);
            return (
              <div key={feature.title} className="rounded-2xl border border-ash-200 bg-white p-6">
                <div className="mb-4 flex size-12 items-center justify-center rounded-xl bg-rebolt-500/10">
                  <Icon className="size-5 text-rebolt-500" />
                </div>
                <h3 className="font-clash text-lg font-medium text-ash-900">{feature.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ash-500">{feature.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 mx-auto max-w-2xl">
          <div className="rounded-2xl border border-ash-200 bg-white p-8">
            <h3 className="text-center font-clash text-xl font-medium text-ash-900 md:text-2xl">
              <span className="text-rebolt-500">Rebolt </span>Pricing
            </h3>

            <div className="mt-6 grid grid-cols-3 gap-px overflow-hidden rounded-xl bg-ash-200">
              <div className="bg-ash-100 px-4 py-3 text-center text-sm font-semibold text-ash-700">Monthly Price</div>
              <div className="bg-ash-100 px-4 py-3 text-center text-sm font-semibold text-ash-700">
                Annual Price ({pricing.annualSavings} savings)
              </div>
              <div className="bg-ash-100 px-4 py-3 text-center text-sm font-semibold text-ash-700">Setup Fee</div>

              <div className="bg-white px-4 py-4 text-center text-base font-medium text-ash-900">
                {pricing.monthlyPrice}
              </div>
              <div className="bg-white px-4 py-4 text-center text-base font-medium text-ash-900">
                {pricing.annualPrice}
              </div>
              <div className="bg-white px-4 py-4 text-center text-base font-medium text-ash-900">
                {pricing.setupFee}
              </div>
            </div>

            <div className="mt-6 flex justify-center">
              <Link
                href="https://cal.com/team/builtright/launch"
                className="inline-flex items-center rounded-full bg-rebolt-500 px-8 py-3.5 text-base font-semibold text-white transition-colors hover:bg-rebolt-600"
              >
                Try Rebolt Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
